'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.deepEquals = deepEquals;
exports.deepCopy = deepCopy;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * @name deepEquals
 * @summary Recursively determines if two objects are equal.
 *
 * @description
 * Recursively determines whether the passed values are equal.
 * If the values are primitive types, they will be directly compared.
 * If the values are objects, each entry in the first will be compared
 * with the corresponding entry in the second.
 *
 * @param {Object} a - the first object to compare
 * @param {Object} b - the second object to compare
 * @returns {Boolean} TRUE if all fields in the object and all subobjects
 * are equal. FALSE otherwise.
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Returns False
 * var result = deepEquals({ a: 1, b: 2 }, { a: 2, b: 3 })
 * */
function deepEquals(a, b) {
  if (arguments.length !== 2) {
    throw new TypeError('2 arguments required, but ' + arguments.length + ' present');
  }

  if (a instanceof Object && b instanceof Object) {
    var keys = Array.from(new Set([].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b)))));
    return keys.every(function (key) {
      return deepEquals(a[key], b[key]);
    });
  }
  if (a instanceof Date || b instanceof Date) {
    return new Date(a).getTime() === new Date(b).getTime();
  }
  return a === b;
}

/**
 * @name deepCopy
 * @summary Recursively copies an object.
 *
 * @description
 * Recursively copies an object and all of its fields. If passed a primitive
 * type, a copy of the value will be returned. If an object is passed, a new
 * object containing copies of all fields will be returned.
 *
 * @param {Object | Number | Boolean} obj - the object to copy
 * @returns {Object} a copy of the passed object.
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Returns { a: 1, b: 2 }
 * var result = deepCopy({ a: 1, b: 2 })
 * */
function deepCopy(obj) {
  if (arguments.length !== 1) {
    throw new TypeError('1 argument required, but ' + arguments.length + ' present');
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce(function (arr, item) {
      return [].concat(_toConsumableArray(arr), [deepCopy(item)]);
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce(function (copy, key) {
      return Object.assign({}, copy, _defineProperty({}, key, deepCopy(obj[key])));
    }, {});
  }

  return {};
}